export const user_getUserInfo = "/user/getUserInfo"; // 获取用户信息
export const user_getUserMoney = "/user/getUserMoney"; // 获取用户信息
export const user_getUserLevel = "/user/getUserLevel"; // 获取用户等级
export const user_getUserNoticeNum = '/user/getUserNoticeNum' // 系统通知未读数量更新
export const user_receiveChatGroupRecord = '/user/receiveChatGroupRecord' // 收到消息
export const user_readChatGroupRecords = '/user/readChatGroupRecords' // 消息改为已读
